// Geo-gated consent: which regions legally require prior opt-in for non-essential
// cookies (analytics/marketing). Those get the blocking modal + default-deny;
// everywhere else gets a dismissible notice + default-on. Strictly-necessary
// cookies (session, security, geo/pricing, the consent choice itself) run
// regardless of region.

/** EU + EEA + UK + Switzerland — prior opt-in required. */
export const STRICT_CONSENT_COUNTRIES: ReadonlySet<string> = new Set([
  // EU 27
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT',
  'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  // EEA (non-EU)
  'IS', 'LI', 'NO',
  // UK + Switzerland
  'GB', 'CH',
]);

export type ConsentRegion = 'strict' | 'open';

/**
 * Classify a visitor's country. **Fail-open**: unknown/empty → 'open' — we'd
 * rather not block the majority (India/US/ROW) when geo can't be resolved. A
 * reliable server-side geo signal shrinks that edge case to near-zero.
 */
export function regionFromCountry(country: string | null | undefined): ConsentRegion {
  if (!country) return 'open';
  return STRICT_CONSENT_COUNTRIES.has(country.toUpperCase()) ? 'strict' : 'open';
}
